module.exports = __webpack_public_path__ + "img/cover.7b91a592.jpg";